import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Checkbox from '../../components/Checkbox';
import { useValeContext } from './context/Vale.context';

interface Props {
  onFiltersClose: () => void;
  onFiltersChange: (newFilters: string[]) => void;
  filtrosVisiblesProductos: string[];
  filtrosVisiblesOtros: string[];
}

const ValesFilters: FC<Props> = ({
  filtrosVisiblesProductos,
  filtrosVisiblesOtros,
}) => {
  const { t } = useTranslation();
  const {
    activeFilters,
    filtrosOtrosActivos,
    addFilterURL,
    addFilter,
  } = useValeContext();
  const toggleFilter = (filter: string) => {
    addFilter(filter);
  };
  const toggleFilterURL = (filter: string) => {
    addFilterURL(filter);
  };

  return (
    <div className="vales-filters">
      <div>
        {filtrosVisiblesProductos.length > 0 ? (
          <>
            <h2 className="bloque-datos__title">
              <span className="divider__square brand-color" />
              <span className="u-margin-right">
                {t('vales.filtroProductos')}
              </span>
            </h2>
            <div className="vales-filters__filters vales-filters__filters--multiple">
              {filtrosVisiblesProductos.map((filter) => {
                return (
                  <Checkbox
                    key={filter}
                    text={filter}
                    value={filter}
                    onChange={toggleFilter}
                    checked={activeFilters.includes(filter)}
                  />
                );
              })}
            </div>
          </>
        ) : null}
      </div>
      <div className="vales-filters__other-filters">
        {/* <div> */}
        {/*  <h2 className="bloque-datos__title"> */}
        {/*    <span className="divider__square brand-color" /> */}
        {/*    <span className="u-margin-right">Marcas</span> */}
        {/*  </h2> */}
        {/*  <div className="vales-filters__filters"> */}
        {/*    {brandFilters.map((filter) => ( */}
        {/*      <Checkbox */}
        {/*        key={filter} */}
        {/*        text={filter} */}
        {/*        value={filter} */}
        {/*        onChange={toggleFilter} */}
        {/*        checked={activeFilters.includes(filter)} */}
        {/*      /> */}
        {/*    ))} */}
        {/*  </div> */}
        {/* </div> */}
        <div>
          {filtrosVisiblesOtros.length > 0 ? (
            <>
              <h2 className="bloque-datos__title">
                <span className="divider__square brand-color" />
                <span className="u-margin-right">{t('vales.filtroOtros')}</span>
              </h2>
              <div className="vales-filters__filters">
                {filtrosVisiblesOtros.map((filter) => (
                  <Checkbox
                    key={filter}
                    text={filter}
                    value={filter}
                    onChange={toggleFilterURL}
                    checked={filtrosOtrosActivos.includes(filter)}
                  />
                ))}
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ValesFilters;
